module.exports = __webpack_public_path__ + "fonts/SpareBank1Title-Regular-Web.91ff381.woff2";